import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CoreService } from 'src/app/shared/services/core.service';

@Component({
  selector: 'app-branding',
  imports: [RouterModule , CommonModule],
  template: `
 <a [routerLink]="['/']">
      <img
        *ngIf="!mini"
        style="width: 80px;"
        src="./assets/images/logos/adFlip-logo-2-removebg.png"
         class="align-middle m-2"
        alt="full logo"
      />
      <img
        *ngIf="mini"
        style="width: 40px;"
        src="./assets/images/logos/adFlip-logo-2-removebg.png"
         class="align-middle m-2"
        alt="mini logo"
      />
    </a>
  `,
})
export class BrandingComponent {
  options = this.settings.getOptions();
  constructor(private settings: CoreService) {}

  get mini() {
  return this.options.sidenavCollapsed;
}
}
